import { AppStaticURL } from '@app/app.settings';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Injector, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NewsService } from '@app/modules/news-modules/news.service';
import { SEOService } from '@app/core/services';
import { DevicesClass } from '@app/core/classes';
import { NewsViewTypes } from '@app/shared/news-item/news-item.component';
import { BreadcrumbsDataModel } from '@app/core/models/breadcrumbs';
import { RoutingConfig } from '@app/routing/routing.config';
import { IBlogPostNewsDetail } from '@app/modules/news-modules/news.models';
import { BehaviorSubject } from 'rxjs';
import { NewsStoryService } from '@app/modules/news-modules/news.story';
import { FavoritesService } from '@app/modules/favorites-modules/favorites.service';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-news-item',
  templateUrl: 'news-detail.component.html',
  styleUrls: [`./news-detail.component.scss`],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class NewsDetailComponent extends DevicesClass implements OnInit {
  public NVType = NewsViewTypes;
  public BreadcrumbsData: BreadcrumbsDataModel = [];
  public NewsDetailData: BehaviorSubject<IBlogPostNewsDetail> = new BehaviorSubject<IBlogPostNewsDetail>(null);

  constructor(injector: Injector,
    public cdr: ChangeDetectorRef,
    private seo: SEOService,
    private router: Router,
    private route: ActivatedRoute,
    private newsService: NewsService,
    private favoritesService: FavoritesService,
    private newsStoryService: NewsStoryService,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);

    const newsId: number = this.route.snapshot.params.id || null;
    if (newsId) {
      this.newsService.getNewsById(newsId).subscribe(
        response => {
          this.NewsDetailData.next(response);

          this.BreadcrumbsData = [
            {
              title: 'Новсти',
              url: '/' + RoutingConfig.News
            },
            {
              title: response.title,
              url: '/' + RoutingConfig.News,
              active: true
            }
          ];

          this.seo.setPageSchema({
            title: response.title,
            description: 'Сервис по поиску музыкантов No1 в России и на Луне',
            image: AppStaticURL + response.picUrl,
            url: ''
          });

          this.onGetFavoritesNews();

          this.cdr.detectChanges();
        },
        error => this.router.navigateByUrl(RoutingConfig.PageErrors + '/' + RoutingConfig.Page404)
      )
    }
  }

  onGetFavoritesNews(): void {
    this.favoritesService.newsFavorites().subscribe(
      response => {
        this.newsStoryService.NewsEventBus.next({
          event: 'onUpdateFavorites',
          data: response.items
        })
      }
    );
  }
}
